<div class="overflow-y-auto px-10 pb-5 flex justify-center">
	<div class="max-w-6xl w-full">
		<div class="flex justify-center mb-10">
			<div class="flex flex-col items-center">
				<div class="flex w-32 h-32">
					<img src="/assets/images/integrations/fct-logo.svg" />
				</div>
				<span
					class="text-sm text-green underline cursor-pointer mb-3 -mt-5"
					(click)="selectInsuranceProvider()"
					[testHook]="testHooks.SelectInsuranceProviderSpan"
					>Switch provider</span
				>
				<app-title-insurance-toolbar
					[provider]="titleInsurance?.provider"
					[propertyUsage]="usageType.COMMERCIAL"
					[orderSubmitted]="currentStep >= 3"
					(cancelOrder)="cancel()"
				></app-title-insurance-toolbar>
			</div>
		</div>

		<div class="flex mt-10 justify-center mx-4">
			<app-step-progress-nav
				class="stepper"
				[steps]="steps"
				[current]="currentStep"
				(stepClicked)="stepClicked($event)"
				[testHook]="testHooks.StepProgressNav"
			></app-step-progress-nav>
		</div>

		<div class="mt-10">
			<app-fct-not-submitted
				*ngIf="currentStep === 0"
				(cancelOrder)="cancel()"
				[orderValid]="orderValid"
				[isCommercial]="true"
				[missing]="missing"
				[outOfOntario]="outOfOntario"
			></app-fct-not-submitted>
		</div>
		<div *ngIf="currentStep === 1" class="mx-10 mt-10">
			<app-form-entry></app-form-entry>
		</div>
		<div *ngIf="currentStep === 2">
			<app-submit-commercial></app-submit-commercial>
		</div>
		<div *ngIf="currentStep === 3">
			<app-enter-policy-details></app-enter-policy-details>
		</div>
		<div *ngIf="currentStep === 4">
			<app-commercial-order-summary
				(goBack)="goBack()"
			></app-commercial-order-summary>
		</div>
	</div>
</div>

<footer
	class="flex flex-1 justify-between items-center py-5 px-5 z-50 bg-grey-lightest mt-5"
	*ngIf="currentStep !== 4"
>
	<div class="flex ml-12">
		<app-button
			*ngIf="currentStep !== 0"
			btn="tertiary"
			(onClick)="goBack()"
			[testHook]="testHooks.BackButton"
			>Back</app-button
		>
	</div>
	<div>
		<atomic-message-bar
			*ngIf="missingFieldsMessage"
			type="warn"
			[icon]="ICON.WARNING"
			[testHook]="testHooks.MessageBar"
		>
			<div class="flex items-center gap-2">
				<p>{{ missingFieldsMessage }}</p>
				<app-icon
					[icon]="ICON.CLOSE"
					class="cursor-pointer"
					(click)="missingFieldsMessage = ''"
					[testHook]="testHooks.CloseIcon"
				></app-icon>
			</div>
		</atomic-message-bar>
	</div>
	<div class="flex mr-12">
		<app-button
			*ngIf="currentStep !== 4"
			(onClick)="continue()"
			[disabled]="nextDisabled"
			[testHook]="testHooks.NextButton"
			>Next</app-button
		>
	</div>
</footer>
